export default __webpack_public_path__ + "static/media/47t.4ea15cb7.jpg";